import React from "react";
import { Modal, Button } from "react-bootstrap";
import ApiRegistryManagerPanel from "./ApiRegistryManagerPanel";

// Verwaltungs-Modal fuer die API-Registry (Produkt-Tab "API" in BoardServices).
// Die eigentliche Verwaltungs-Oberflaeche liegt in ApiRegistryManagerPanel und
// wird ebenso von der eigenstaendigen Seite (BoardApiConfig) genutzt, damit es
// keine Doppellogik gibt. Props (show/onHide/onChanged) bleiben unveraendert.
const ApiRegistryManagerModal = ({ show, onHide, onChanged }) => {
  return (
    <Modal show={show} onHide={onHide} size="lg" backdrop="static">
      <Modal.Header closeButton>
        <Modal.Title>API-Administration</Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <ApiRegistryManagerPanel active={show} onChanged={onChanged} />
      </Modal.Body>
      <Modal.Footer>
        <Button variant="secondary" onClick={onHide}>
          Schliessen
        </Button>
      </Modal.Footer>
    </Modal>
  );
};

export default ApiRegistryManagerModal;
